/* eslint-disable complexity */
import { useCalendarContext } from '@/domain/termine/features/Calendar/shared/CalendarContext';

type Direction = 'right' | 'left' | 'bottom' | 'top';

export function usePopoverDirection(): Direction {
  const { colIndex = 0, rowIndex = 0 } = useCalendarContext();

  if (colIndex === 0 && rowIndex > 0) return 'right';
  if (colIndex === 6 && rowIndex > 0) return 'left';
  if (rowIndex < 3) return 'bottom';

  if (rowIndex > 3) return 'top';

  return 'top';
}
